/**This class is automatically generated by LayaAirIDE, please do not make any modifications. */


/**
 * scenes/GamePlay.ls
 */
export class PhysicsGameMainRTBase extends Laya.Scene {
    public drop_line!: Laya.Image;
    public title!: Laya.Image;
    public sy!: Laya.Label;
    public leftCount!: Laya.Label;
    public score!: Laya.Label;
    public df!: Laya.Label;
    public t_score!: Laya.Label;
    public combo!: Laya.FontClip;
    public start_tip!: Laya.Label;
}

